export const isValidUrl = input => !(typeof input === 'undefined' || input === null || input.length === 0);

export const getQueryString = obj => {
    let params = [];

    for (let p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p)) {
            let k = p,
                v = obj[p];

            if (typeof v === 'undefined' || v === null || (typeof v === 'string' && v.length === 0)) continue;

            params.push(
                (v !== null && typeof v === 'object')
                    ? getQueryString(v, k)
                    : encodeURIComponent(k) + '=' + encodeURIComponent(v)
            );
        }
    }

    return params.filter(Boolean).join('&');
}

export const getResponseHeaders = (req) => {
    let headers = {};

    (req.getAllResponseHeaders() || '').trim().split(/[\r\n]+/).forEach(line => {
        let parts = line.split(': ');

        headers[parts.shift()] = parts.join(': ');
    });

    return headers;
}

export const getErrorResponse = (req, headers) => ({
    response: req.response,
    status: req.status,
    statusText: req.statusText,
    headers
});